import { Injectable, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ConfirmDialog } from './confirm-dialog/confirm-dialog';

@Injectable()
export class DialogService {
  /***************Constructor***************/
  constructor(private dialog: MatDialog) {}
  /***************Constructor***************/

  /***************Helper Methods***************/

  confirm(confirm: ConfirmDialog) {
    let dialogRef: MatDialogRef<ConfirmDialogComponent>;
    dialogRef = this.dialog.open(
      ConfirmDialogComponent,
      this.getConfig(confirm.config)
    );
    dialogRef.componentInstance.confirm = confirm;
    return dialogRef;
  }

  /***************Helper Methods***************/

  /***************Private Methods***************/

  private getConfig(dialogConfig: MatDialogConfig): MatDialogConfig {
    const config = new MatDialogConfig();
    config.disableClose = true;
    config.autoFocus = true;
    return Object.assign(config, dialogConfig);
  }

  /***************Private Methods***************/
}
